/* eslint-disable import/extensions */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
import React, { useEffect, useState, useCallback } from "react";
import Env from "Consts/env";
import axios from "axios";
import ClientCookies from "js-cookie";
import {
	checkResponseOnIsr,
	isProduction,
} from "Helpers/utils";
import dynamic from "next/dynamic";
import * as metaPixel from "Helpers/fb-pixel";
import * as tiktokPixel from "Helpers/tiktok-pixel";
import * as gtag from "Helpers/gtag";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/router";
import vars from "Consts/vars";
import { isMobile } from "react-device-detect";
import { wrapper } from "@/Store/index";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";

const Layout = dynamic(
	() => import("Containers/layout"),
	{ ssr: true },
);

const ChildDetailPage = dynamic(
	() => import("Containers/child-detail-page"),
	{ ssr: false },
);

const EmptyState = dynamic(
	() => import("Components/empty-state"),
	{ ssr: false },
);

/* eslint-disable react/prop-types */
function Detail(props) {

	const { query } = useRouter();
	const authorization = ClientCookies.get("token") || null;
	const userId = ClientCookies.get("user_id") || null;
	const usrname = ClientCookies.get("usrname") || null;
	const data = props;

	const getStoreSelf = useSelector((state) => (state.storeSelf));

	const dispatch = useDispatch();
	const getStoreCategoryDesktop = useSelector((state) => {

		const categoryNavigationDesktop = [];
		const resStoreCategoryDesktop = state.storeCategoryDesktop.data && typeof state.storeCategoryDesktop.data.data !== "undefined"
			? state.storeCategoryDesktop.data
			: null;

		resStoreCategoryDesktop?.data[0]?.children_data?.filter((val) => val.include_in_menu === "1")?.map((item) => {

			categoryNavigationDesktop.push({
				id: item.entity_id,
				name: item.category_name,
				slug: item.category_path,
				items: item.children_data.length > 0
					? item.children_data?.map((child) => ({
						id: child.entity_id,
						name: child.category_name,
						slug: child.category_path,
						items: child.children_data.length > 0
							? child.children_data?.map((childs) => ({
								id: childs.entity_id,
								name: childs.category_name,
								slug: childs.category_path,
								items: childs.children_data.length > 0
									? childs.children_data?.map((lastChilds) => ({
										id: lastChilds.entity_id,
										name: lastChilds.category_name,
										slug: lastChilds.category_path,
									})) : [],
							})) : [],
					})) : [],
			});

		});
		categoryNavigationDesktop.splice(1, 0, {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		});
		return categoryNavigationDesktop;

	});
	const [getQuoteIdErrMessage, setQuoteIdErrMessage] = useState();
	const [review, setReview] = useState(null);
	const [isFetchWishlist, setIsFetchWishlist] = useState(false);
	const [similar, setSimilar] = useState(false);

	const HandleSimilarProduct = () => {

		window.location.href = "/";

	};

	const HandleGetReview = async (params) => {

		try {

			const reviewList = await axios.get(`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-user/review_list?product_id=${params}`);
			if (reviewList && reviewList.data) {

				if (Array.isArray(reviewList.data.data)) {

					setReview(reviewList.data.data);

				} else {

					setReview([]);

				}

			}

		} catch (err) {

			setReview([]);

		}

	};

	const HandleGetWishlist = async (params) => {

		try {

			const wishList = await axios({
				method: "GET",
				url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-user/product/${params.userid}`,
				headers: {
					userid: params.userid,
					productid: params.productid,
				},
			});

			if (wishList && wishList.data) {

				setIsFetchWishlist(wishList.data.data.is_wished);

			}

		} catch (err) {

			setIsFetchWishlist(false);

		}

	};

	const HandleGetSimilar = async (params) => {

		try {

			const similarList = await axios.get(`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-product/${params}/similar`);
			if (similarList && similarList.data) {

				if (Array.isArray(similarList.data.data)) {

					let similarProductFiltered = similarList.data.data;
					if (similarList.data.data.length > 4) {

						similarProductFiltered = similarList.data.data.splice(0, 4);

					}
					setSimilar(similarProductFiltered);

				} else {

					setSimilar([]);

				}

			}

		} catch (err) {

			setSimilar([]);

		}

	};

	useEffect(() => {

		const dataProduct = data?.productDetail?.data?.product;

		if (isProduction) {

			// Track ViewContent event
			metaPixel.standardEvent("ViewContent", {
				content_name: dataProduct?.name,
				content_type: "product",
				content_id: dataProduct?.id,
				brand: dataProduct.brands.brand_name,
				sku: dataProduct?.sku,
				content_ids: [dataProduct?.id],
				value: dataProduct?.price,
				currency: "IDR",
				qty: dataProduct?.qty,
			});

			tiktokPixel.track("ViewContent", {
				content_name: dataProduct?.name,
				content_type: "product",
				content_id: dataProduct?.id,
				brand: dataProduct.brands.brand_name,
				sku: dataProduct?.sku,
				content_ids: [dataProduct?.id],
				value: dataProduct?.price,
				currency: "IDR",
				qty: dataProduct?.qty,
			});

			gtag.event({
				eventName: "view_item",
				parameter: {
					content_name: dataProduct?.name,
					content_type: "product",
					content_id: dataProduct?.id,
					brand: dataProduct.brands.brand_name,
					sku: dataProduct?.sku,
					content_ids: [dataProduct?.id],
					value: dataProduct?.price,
					currency: "IDR",
					qty: dataProduct?.qty,
					event_category: "view_item",
					event_label: "view_item",
				},
			});

		}

		if (dataProduct?.id) {

			HandleGetSimilar(dataProduct?.id);

		} else {

			setSimilar([]);

		}

		if (dataProduct?.fdbr_product_id) {

			HandleGetReview(dataProduct?.fdbr_product_id);

		} else {

			setReview([]);

		}

	}, [data?.productDetail?.data?.product, userId]);

	useEffect(() => {

		const dataProduct = data?.productDetail?.data?.product;

		if (dataProduct?.fdbr_product_id && userId) {

			HandleGetWishlist({
				productid: dataProduct?.fdbr_product_id,
				userid: userId,
				dataProduct,
			});

		} else {

			setIsFetchWishlist(false);

		}

	}, [data?.productDetail?.data?.product, userId]);

	useEffect(() => {

		/* START CREATE QUOTE ID */
		const createQuote = async () => {

			// const QuoteIdErrMessageTmp = await HandleCreateQuote({});
			const QuoteIdErrMessageTmp = null;
			setQuoteIdErrMessage(QuoteIdErrMessageTmp);

		};
		createQuote();
		/* END CREATE QUOTE ID */

	}, []);

	useEffect(() => {

		dispatch(
			loadCategoryDesktop({
				payload: {
				},
			}),
		);

	}, []);

	const productDetailData = data?.productDetail?.data;

	const passStoreSelf = useCallback(() => {

		if (authorization && usrname) {

			return getStoreSelf;

		}
		return { status: vars.FETCH_RESULT };

	}, [getStoreSelf]);

	return (
		<Layout
			home
			title="Femaledaily"
			titleNavbar={productDetailData?.product?.name}
			typeNavbarSecondary="type-1"
			ismobile={isMobile}
			self={passStoreSelf()}
			categoryDesktop={getStoreCategoryDesktop}
			getQuoteIdErrMessage={getQuoteIdErrMessage}
			metaDescription={productDetailData?.product?.meta?.meta_description}
			metaKeywords={productDetailData?.product?.meta?.meta_keywords}
			metaTitle={productDetailData?.product?.meta?.meta_title.split("|")[0]}
			isAdaptiveLoad={isMobile}
		>
			{
				productDetailData?.product?.is_available ? (
					<ChildDetailPage
						isMobile={isMobile}
						data={productDetailData}
						type={productDetailData?.product?.type_id ?? data.query.type}
						query={query}
						review={review}
						isFetchWishlist={isFetchWishlist}
						similar={similar}
					/>
				) : (
					<EmptyState
						title="Oops... Product Not Available"
						subtitle="Take a look at other products in this category!"
						handleEmpty={() => HandleSimilarProduct()}
						buttonTitle="VIEW SIMILAR PRODUCT"
					/>
				)
			}
		</Layout>
	);

}

export async function getStaticPaths() {

	return {
		paths: [],
		// Enable statically generating additional pages
		// For example: `/posts/3`
		fallback: "blocking",
	};

}

export const getStaticProps = wrapper.getStaticProps(
	async ({
		params,
	}) => {

		const headers = { ...Env.HEADERS };
		const method = "GET";
		const options = { headers, method };

		const productDetail = await fetch(`${process.env.NEXT_PUBLIC_MAGENTO_BS}/magento/product/${params.slug}`, options);

		// const categoryDesktop = await fetch(`${process.env.NEXT_PUBLIC_MAGENTO_BS}/magento/category/2`, options);

		// const categoryNavigationDesktop = [];
		// const brands = {
		// 	id: 200,
		// 	name: "Brands",
		// 	slug: "brands",
		// 	items: [],
		// };

		const getStoreProductDetail =	await checkResponseOnIsr(productDetail);

		// const getStoreCategoryDesktop =	await checkResponseOnIsr(categoryDesktop);

		// getStoreCategoryDesktop
		// 	&& getStoreCategoryDesktop.data[0]
		// 	&& getStoreCategoryDesktop.data[0].children_data
		// 	&& getStoreCategoryDesktop.data[0].children_data
		// 		.filter((val) => val.include_in_menu === "1")
		// 		.map((item) => {

		// 			categoryNavigationDesktop.push({
		// 				id: item.entity_id,
		// 				name: item.category_name,
		// 				slug: item.category_path,
		// 				items:
		// 					item.children_data.length > 0
		// 						? item.children_data.map((child) => ({
		// 							id: child.entity_id,
		// 							name: child.category_name,
		// 							slug: child.category_path,
		// 							items:
		// 									child.children_data.length > 0
		// 										? child.children_data.map(
		// 											(childs) => ({
		// 												id: childs.entity_id,
		// 												name: childs.category_name,
		// 												slug: childs.category_path,
		// 												items:
		// 														childs
		// 															.children_data
		// 															.length > 0
		// 															? childs.children_data.map(
		// 																(
		// 																	lastChilds,
		// 																) => ({
		// 																	id: lastChilds.entity_id,
		// 																	name: lastChilds.category_name,
		// 																	slug: lastChilds.category_path,
		// 																}),
		// 															  )
		// 															: [],
		// 											}),
		// 										  )
		// 										: [],
		// 						  }))
		// 						: [],
		// 			});

		// 		});
		// categoryNavigationDesktop.splice(1, 0, brands);

		return getStoreProductDetail
			? {
				props: {
					productDetail: getStoreProductDetail,
					// isMobile,
					// storeCategoryDesktop: categoryNavigationDesktop || null,
					// getQuoteIdErrMessage,
					// userId: userId || null,
				},
				revalidate: 15,
			  }
			: { notFound: true };

	},
);

export default Detail;
